module.exports = __webpack_public_path__ + "fonts/font-icon-Enerdata.6c51f51.ttf";